import { Heading, Image, Stack, Text, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import progressSpinner from "../../assets/post-login/ProgressSpinner.png";
import { useTranslation } from "react-i18next";

export const PostLoginOnboardningDone = () => {
	const { t } = useTranslation();

	return (
		<Stack alignItems={"center"} gap={ThemeSpaceVariable.None}>
			<Image width={"6rem"} margin={"auto"} src={progressSpinner} mb={ThemeSpaceVariable.Large} />
			<Heading as="h1">{t("post_login_onboarding_done_title")}</Heading>
			<Text m={ThemeSpaceVariable.Medium} textAlign={"center"}>
				{t("post_login_onboarding_done_text")}
			</Text>
		</Stack>
	);
};
